import React from 'react';
import PropTypes from 'prop-types';
import './Main.css';

const Main = ({ logoSrc }) => {
  return (
    <main className="main-content">
      <div className="main-content__container">
        <img 
          src={logoSrc || `${process.env.PUBLIC_URL}/images/CCLOGO.png`} 
          alt="Cyber Circuit Logo" 
          className="main-content__logo" 
        />
        <div className="main-content__text">
          <h1 className="main-content__mission">First Simulation Mission: Cyber Circuit</h1>
          <h2 className="main-content__title">MASTER CYBER CIRCLET</h2>
          <p className="main-content__description">
            "In Cyber Circlet, use primary and secondary weapons to tackle diverse missions. 
            Exiting simulations swiftly grants bonus points, while defeating monsters and 
            gathering data boosts your score, propelling you up the leaderboard."
          </p>
          <button className="main-content__button" aria-label="Start the Cyber Circuit game">PLAY</button>
        </div>
      </div>
    </main>
  );
};

Main.propTypes = {
  logoSrc: PropTypes.string,
};

Main.defaultProps = {
  logoSrc: `${process.env.PUBLIC_URL}/images/CCLOGO.png`,
};

export default Main;
